import * as React from "react";
import { Row, Col } from "react-bootstrap";
import { Window } from "@progress/kendo-react-dialogs";
import { DropDownListCustomHandle } from "./DropDownlistCustom";
import { Button } from "@progress/kendo-react-buttons";
import {
  Form,
  Field,
  FormElement,
  FieldWrapper,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { cancelIcon, saveIcon } from "@progress/kendo-svg-icons";
import { DropDownListField } from "./FormComponents";
import { WindowLabelingChildLabel } from "./WindowLabelingChildLabel";
import { requiredValidator } from "../utils/validators";
import { AnnotationService } from "../services/Annotation";

interface WindowLabelingProps {
  entityApiUrl: string;
  labelApiUrl: string;
  cancelEdit: () => void;
  onSubmit: (event: any) => void;
  item: any;
  autoBind?: boolean;
  isDropDownDisabled?: boolean;
  preventCompleteDocWithoutLabel?: number;
}

export const WindowLabeling = (props: WindowLabelingProps) => {
  const { cancelEdit, onSubmit, item, entityApiUrl, labelApiUrl,autoBind } = props;
  const formRef = React.useRef<any>(null);
  const window = React.useRef<Window>(null);
  const entityDropdownRef = React.useRef<DropDownListCustomHandle>(null);
  const [entityValue, setEntityValue] = React.useState<any>(null);
  const annotationService = new AnnotationService();
  const [annotationId, setAnnotationId] = React.useState<number>(0);
  const labelDropdownRef = React.useRef<DropDownListCustomHandle>(null);
  const [labelValue, setLabelValue] = React.useState<any>(null);
  const [labelValue2, setLabelValue2] = React.useState<any>(null);
  const [hasRenderLabel2, setHasRenderLabel2] = React.useState<boolean>(false);
  const [labelValue3, setLabelValue3] = React.useState<any>(null);
  const [hasRenderLabel3, setHasRenderLabel3] = React.useState<boolean>(false); 
  const [labelApiUrlSet, setLabelApiUrlSet] = React.useState<string>(labelApiUrl);
  const [loadLabels, setLoadLabels] = React.useState<boolean>(false);
  const [, setLoadLabels2] = React.useState<boolean>(false);
  const [, setLoadLabels3] = React.useState<boolean>(false);
  const [submitting, setSubmitting] = React.useState(false);
  
 const maximizeMinimizeButton = () => {
    return <span></span>
  }

  const handleSetValueEntity = (event: DropDownListChangeEvent, renderProps: any) => {
    setEntityValue(event.target.value);
    setLabelApiUrlSet(labelApiUrl + `?entityId=${event.target.value?.EntityId}`);
    setLoadLabels(true);
    renderProps.onChange("label_dropdown", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_2", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });  
    setLabelValue(null);
    setLabelValue2(null);
    labelDropdownRef.current?.settingValue(null);
    setLabelValue3(null);
    setHasRenderLabel2(false);
    setHasRenderLabel3(false);
    event.nativeEvent.preventDefault();

  };

  const handleResetValueEntity = (e: Event, renderProps: any) => {
    renderProps.onChange("entity_dropdown", {
      value: null,      
    });  
    setEntityValue(null);
    renderProps.onChange("label_dropdown", {
      value: null,
    });    
    renderProps.onChange("label_dropdown_2", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });  
    setLabelValue(null);
    labelDropdownRef.current?.settingValue(null);
    setLabelValue2(null);
    setLabelValue3(null);
    setHasRenderLabel2(false);
    setHasRenderLabel3(false);
  }

  // Event to open the child label dropdown
 const handleSetValueLabel = (event: DropDownListChangeEvent, renderProps: any) => {
    setLabelValue(event.target.value);
    setLoadLabels(true);
    renderProps.onChange("label_dropdown", {
      value: event.target.value,
    }); 
    renderProps.onChange("label_dropdown_2", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });  
    setLabelValue2(null);
    labelDropdownRef.current?.settingValue(event.target.value);
    setLabelValue3(null);
    setHasRenderLabel2(false);      
    setHasRenderLabel3(false);
    event.nativeEvent.preventDefault();

  };
  React.useEffect(() => {
    if(labelValue && labelValue.HasChildren){
      setHasRenderLabel2(true);      
    }
  }, 
  [labelValue]);


  const handleSetValueLabel2 = (event: DropDownListChangeEvent, renderProps: any) => {
    setLabelValue2(event.target.value);
    setLoadLabels(true);

    renderProps.onChange("label_dropdown_2", {
      value: event.target.value,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });  
    setLabelValue3(null);
    setHasRenderLabel3(false);
    event.nativeEvent.preventDefault();
  };
  
  React.useEffect(() => {
    if(labelValue2 && labelValue2.HasChildren){
      setHasRenderLabel3(true);      
    }
  }, 
  [labelValue2]);


  const handleSetValueLabel3 = (event: DropDownListChangeEvent) => {
    setLabelValue3(event.target.value);
    event.nativeEvent.preventDefault();
  };

  // Event to reset the label dropdown
  const handleResetValueLabel = (e: Event, renderProps: any) => {
    renderProps.onChange("label_dropdown", {
      value: null,
    });    
    renderProps.onChange("label_dropdown_2", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });  
    setLabelValue(null);
    setLabelValue2(null);
    setLabelValue3(null);
    setHasRenderLabel2(false);
    setHasRenderLabel3(false);
  }  

  const handleResetValueLabel2 = (e: Event, renderProps: any) => {
    renderProps.onChange("label_dropdown_2", {
      value: null,
    }); 
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });   
    setLabelValue2(null);
    setLabelValue3(null);
    setHasRenderLabel3(false);
  } 
  
  const handleResetValueLabel3 = (e: Event, renderProps: any) => {
    renderProps.onChange("label_dropdown_3", {
      value: null,
    });    
    setLabelValue3(null);
  } 

  const handleSubmit = (dataItems: any) => {
    onSubmit(dataItems);
    setSubmitting(true);
  }

  // To replace previous string concatenation on labelApiUrlSet + `&$filter=ParentId eq null` 
  React.useEffect(() => {
    if (entityValue && labelDropdownRef.current) {
        labelDropdownRef.current?.setValueFilter( {
          logic: "and",
          filters: [                
            {
              field: "ParentId",
              operator: "eq",
              value: null
            }
          ]
        });;
    }
}, [entityValue]);

  const labelProperties = React.useMemo(() => ({
    id:"label_dropdown"   ,            
    keyField:"LabelId",
    name:"label_dropdown",
    component:(props:any )=><DropDownListField {...props} autoBind={autoBind || loadLabels}/>,
    textField: "LabelDescription",
    odataApiUrl: entityValue
    ? labelApiUrlSet
    : null, // set URL to null if entityValue is null
    label:"Label",             
    forwardRef:labelDropdownRef,
    validator:requiredValidator,    
    value:labelValue  
  }), [entityValue]);
  const label_2_Properties = React.useMemo(() =>(renderProps : FormRenderProps)=> ({
    Id:"label_dropdown_2",
    Name:"label_dropdown_2",
    LabelApiUrl:labelApiUrlSet,
    KeyField:"LabelId",
    TextField:"LabelDescription",
    Label:"Label",
    EntityValue: entityValue?.EntityId,
    ParentLabelId: labelValue?.LabelId,
    onChange: (e: DropDownListChangeEvent)=> handleSetValueLabel2(e, renderProps),
    onReset: (e: Event) => handleResetValueLabel2(e, renderProps),
    Value:labelValue2  
  }), [labelValue?.LabelId]);
  const label_3_Properties = React.useMemo(() => (renderProps :FormRenderProps)=>({
    Id:"label_dropdown_3",
    Name:"label_dropdown_3",
    LabelApiUrl:labelApiUrlSet,
    KeyField:"LabelId",
    TextField:"LabelDescription",
    Label:"Label",
    EntityValue: entityValue?.EntityId,
    ParentLabelId: labelValue2?.LabelId,
    onChange:(e: DropDownListChangeEvent)=> handleSetValueLabel3(e),
    onReset:(e: Event) => handleResetValueLabel3(e, renderProps),
    Value:labelValue3 
  }), [labelValue2?.LabelId]);

  React.useEffect(() => {
    if(item && item.entity_dropdown){    
      setAnnotationId(item.Id);
      // Entity     
      entityDropdownRef.current?.settingValue(item.entity_dropdown);          
      setEntityValue(item.entity_dropdown);
      setLabelApiUrlSet(labelApiUrl  + `?entityId=${item.entity_dropdown.EntityId}`);
      setLoadLabels(true); 

      formRef.current.onChange("entity_dropdown", {
        value: item.entity_dropdown,
      });
      annotationService.GetAnnotationsEntityLabels(
        item.entity_dropdown.EntityId, item.label_dropdown?.LabelId,
        item.label_dropdown_2?.LabelId, item.label_dropdown_3?.LabelId
      ).then((result) => {
        // Labels loaded
        if(result.length === 0){
          return;
        }
        var firstLabel = result.find((x:any) => x.LabelId === item.label_dropdown.LabelId);
        if(firstLabel){
          if(firstLabel.HasChildren){
            setHasRenderLabel2(true);  
          }
          setLabelValue(firstLabel);   
          formRef.current.onChange("label_dropdown", {
            value:firstLabel,
          });        
          labelDropdownRef.current?.settingValue(firstLabel);        

          setLoadLabels(true); 
        }

        var secondLabel = result.find((x:any) => x.LabelId === item.label_dropdown_2?.LabelId);
        if(secondLabel){
          if(secondLabel.HasChildren){
            setHasRenderLabel3(true);  
          }
          setLabelValue2(secondLabel);      
          formRef.current.onChange("label_dropdown_2", {
            value:secondLabel,
          });
          setLoadLabels2(true); 
        }

        var thirdLabel = result.find((x:any) => x.LabelId === item.label_dropdown_3?.LabelId);
        if(thirdLabel){
          if(thirdLabel.HasChildren){
            setHasRenderLabel3(true);  
          }
          setLabelValue3(thirdLabel);      
          formRef.current.onChange("label_dropdown_3", {
            value:thirdLabel,
          });
          setLoadLabels3(true); 
          }
      });
    }  
  }, []);
  return (
    <Form  
      initialValues={item}     
      onSubmit={handleSubmit}  
      ref={formRef}    
      render={(renderProps) => {
       
        const dynamicLabelProperties = {
          ...labelProperties,
          onChange: (e:any) => handleSetValueLabel(e, renderProps),
          handleResetValue: (e:any) => handleResetValueLabel(e, renderProps),
        };
         return <Window ref={window} title="Labeling" onClose={submitting ? undefined : cancelEdit} initialWidth={500} initialHeight={550} modal={true} resizable={false} doubleClickStageChange={false} maximizeButton={maximizeMinimizeButton} minimizeButton={maximizeMinimizeButton}>
            <FormElement>
              <FieldWrapper>
                <Field name={"Id"} component={props => <input {...props} type="hidden" value={annotationId} />} />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                 id={"entity_dropdown"}               
                 keyField={"EntityId"}
                 name={"entity_dropdown"}
                 component={DropDownListField}
                 textField={"Description"}
                 odataApiUrl={entityApiUrl}
                 label={"Entity"}               
                 onChange={(e: DropDownListChangeEvent) => handleSetValueEntity(e, renderProps)}
                 handleResetValue={(e: Event) => handleResetValueEntity(e, renderProps)}
                 forwardRef={entityDropdownRef} 
                 value={entityValue}
                 disabled={props.isDropDownDisabled}
                 validator={requiredValidator}
                 clearButton={!props.isDropDownDisabled} 

                />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                 {...dynamicLabelProperties}
                />
              </FieldWrapper>
             {hasRenderLabel2 && (
              <WindowLabelingChildLabel
              {...label_2_Properties(renderProps)}
              required={props.preventCompleteDocWithoutLabel !== 0}
              />
              )}  
              {hasRenderLabel3 && ( 
                <WindowLabelingChildLabel
                {...label_3_Properties(renderProps)}
                required={props.preventCompleteDocWithoutLabel !== 0}
              /> 
              )}
              <Row className="pt-4 k-buttons-end">
              <Col sm={3}>
                <Button onClick={cancelEdit} icon="cancel" svgIcon={cancelIcon} themeColor={"secondary"}>
                  Cancel
                </Button>
              </Col>
              <Col sm={3}>
                {submitting ? (
                <Button
                  themeColor={"primary"}
                  disabled={true}
                >
                  <span className="k-icon k-i-loading"></span>&nbsp;Saving
                </Button>
                ) : (
                <Button
                  type={"submit"}
                  themeColor={"primary"}
                  disabled={!renderProps.allowSubmit}
                  icon="save"
                  svgIcon={saveIcon}
                >
                  Save
                </Button>
                )}
              </Col>
              </Row>       
              
            </FormElement>
            {submitting && (
              <div className="spinner-overlay">
                <span className="k-icon k-i-loading k-spin" style={{ fontSize: "48px" }}></span>
              </div>
            )}
          </Window>
      }}
    />
  );
}
  